module.exports = __webpack_public_path__ + "assets/images/green-xmas-10.jpg?v=75ec6573";